<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
        title="缴费记录"
        left-arrow
        :fixed=flexfalg
        @click-left="onClickLeft"
      />
      <div class="top"></div>
      <!-- <Nav :title="'缴费记录'" :fixed="true"></Nav>
      <div class="top"> -->
       
    </div>
    <div class="paycard" v-for="(item,index) in payHisInfo" :key="index">
      <div class="head">
        <div></div>
        <div>{{name}}</div>
        
      </div>
      <div claass="content">
        <div class="Crow">
          <div>发票号：{{item.invoiceNo}}</div>
          <div class="green">已缴费</div>
        </div>
        <div class="Crow">
          <div>费用</div>
          <div>￥{{item.amount}}</div>
        </div>
       <div class="Crow">
          <div>付款时间</div>
          <div>{{item.operDate}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../../components/nav.vue";
export default {
   data() {
    return {
      flexfalg:true,
      clientId:"",
      name:"",
      payHisInfo:[],
    };
  },
  components:{
    Nav
  },
  mounted(){
     if (this.$route.query) {
      this.clientId = this.$route.query.clientId;
      this.name = this.$route.query.name
    }
    if (!this.clientId || this.clientId == "") {
      // this.Dialog();
      this.$router.push('/confUser')
      return;
    }
    this.getpayhistoryinfo()
  },
  methods:{
    onClickLeft(){
      this.$router.push('/index');
    },
   Dialog() {
      // console.log(123)
      this.$dialog
        .confirm({
          message: "请选择就诊人信息",
        })
        .then(() => {
          this.$router.push('/confUser')
        })
        .catch(() => {
          // on cancel
          this.$router.push("/index");
        });
    },
    //获取列表
    async getpayhistoryinfo(medCardNo) {
       this.$showLoad();
      let url = "/outpatientfee/queryprepayrecord";
      let res_data = {
        medCardNo: this.clientId,
      };
      await this.$axios_request.request_data(
        "nodeserver",
        url,
        "POST",
        res_data,
        (data) => {
          console.log(data.data)
          this.payHisInfo = data.data
            this.$hideLoad();
        }
      );
      // this.isLoad = true
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top{
  height: 50px;
}
  .paycard {
    padding: 5px;
    width: 90%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 15px;
    margin: 0px auto;
    margin-top: 8px;
    margin-bottom: 8px;
    box-shadow: 0 8px 12px #6666;
  }
  .head {
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #5b8df6;
    font-size: 16px;
  }
  .content {
    width: 90%;
    
    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 5px auto;
  }
  .Crow {
    color:#747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .gold{
        color: #e74c3c;
    }
    .green{
        color: #2ed573;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }

  
}
</style>